module.exports = __webpack_public_path__ + "e90cafd23c7a0cb2389fc5ec1caa1556.woff2";